import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
/**
 * @description Retrieve the list of all validator stashes
 */

export function stashes(instanceId, api) {
  return memo(instanceId, function () {
    return api.query.staking.validators.keys().pipe(map(function (keys) {
      return keys.map(function (_ref) {
        var _ref$args = _slicedToArray(_ref.args, 1),
            validatorId = _ref$args[0];

        return validatorId;
      }).filter(function (a) {
        return a;
      });
    }));
  });
}